var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarouselNextIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    fillOpacity: 0.5,
    stroke: "#D8DFE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 20.7L22.7 26.7C22.5 26.9 22.3 27 22 27C21.7 27 21.5 26.9 21.3 26.7C20.9 26.3 20.9 25.7 21.3 25.3L25.6 21H12C11.4 21 11 20.6 11 20C11 19.4 11.4 19 12 19H25.6L21.3 14.7C20.9 14.3 20.9 13.7 21.3 13.3C21.7 12.9 22.3 12.9 22.7 13.3L28.7 19.3C28.8 19.4 28.9 19.5 28.9 19.6C29 19.8 29 20.1 28.9 20.4C28.9 20.5 28.8 20.6 28.7 20.7Z",
    fill: "#3876BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25325_14285",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 13,
    width: 18,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 20.7L22.7 26.7C22.5 26.9 22.3 27 22 27C21.7 27 21.5 26.9 21.3 26.7C20.9 26.3 20.9 25.7 21.3 25.3L25.6 21H12C11.4 21 11 20.6 11 20C11 19.4 11.4 19 12 19H25.6L21.3 14.7C20.9 14.3 20.9 13.7 21.3 13.3C21.7 12.9 22.3 12.9 22.7 13.3L28.7 19.3C28.8 19.4 28.9 19.5 28.9 19.6C29 19.8 29 20.1 28.9 20.4C28.9 20.5 28.8 20.6 28.7 20.7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25325_14285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8H32V32H8V8Z",
    fill: "#3876BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselNextIcon);
export default __webpack_public_path__ + "static/media/CarouselNextIcon.b4b4580e5abb4721a65a2b4a54b1e93b.svg";
export { ForwardRef as ReactComponent };